import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Checkbox, IconButton, LinearProgress, Pagination, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Loader from "../components/utilComponents/Loader";
import { FiCommand } from "react-icons/fi";

const exportToCsv = (messages) => {
  const rows = messages.map((message) => {
    return {
      ThreadLink: `${process.env.REACT_APP_FRONTEND_URL}/?thread-id=${message.threadId}`,
      Question: message.question,
      Answer: stripHtmlAndExtractUrls(message.answere || ""),
      CreatedAt: `${new Date(message.createdAt).toLocaleString()} (${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      })`,
    };
  });

  // Convert rows to CSV
  const headers = ["ThreadLink", "Question", "Answer", "CreatedAt"];
  const csvString = [
    headers.join(","), // Add headers row
    ...rows.map((row) =>
      headers
        .map((header) => `"${row[header]?.replace(/"/g, '""') || ""}"`)
        .join(",")
    ),
  ].join("\n");

  // Create a Blob and trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const fileName = "messages_export.csv";
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};
const stripHtmlAndExtractUrls = (html) => {
  // Match and extract URLs from <a> tags
  const urlPattern = /<a [^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/g;
  let match;
  const urls = [];

  // Replace <a> tags with plain URLs
  const cleanedHtml = html.replace(urlPattern, (fullMatch, href, linkText) => {
    urls.push(href); // Collect URLs
    return `${linkText} (${href})`; // Replace with plain text and URL
  });

  // Strip remaining HTML tags
  return cleanedHtml.replace(/<\/?[^>]+(>|$)/g, "");
};
export default function AllMessages() {
  const [messages, setMessages] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  //   const [limit, setLimit] = useState(10);

  const fetchMessagesForExport = async (records) => {
    const token = localStorage.getItem("auth-token");
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/get-all-messages?page=1&limit=${records}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.messages;
  };

  const fetchSelectedMessagesForExport = async (threadIds) => {
    const token = localStorage.getItem("auth-token");
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/messages-from-db-by-ids/export`,
      {
        threadIds: threadIds,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.messages;
  };

  const [selectedMessages, setSelectedMessages] = useState([]);

  const handleCheckboxChange = (threadId, isChecked) => {
    setSelectedMessages((prevSelected) =>
      isChecked
        ? [...prevSelected, threadId]
        : prevSelected.filter((id) => id !== threadId)
    );
  };
  const fetchMessagesFromThread = async (threadId) => {
    const token = localStorage.getItem("auth-token");
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/messages-from-db/${threadId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data.messages.reverse();
  };
  const [loadingExport, setLoadingExport] = useState(false);

  const onExport = async (e) => {
    e.preventDefault();
    setLoadingExport(true);

    try {
      const messages = await fetchMessagesForExport(totalRecords);

      exportToCsv(messages);

      console.log("Export completed!");
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setLoadingExport(false);
    }
  };
  const onSelectedExport = async (e) => {
    e.preventDefault();
    setLoadingExport(true);
    try {
      const messages = await fetchSelectedMessagesForExport(selectedMessages);
      exportToCsv(messages);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setLoadingExport(false);
    }
  };
  const onChatExport = async (e, threadId) => {
    e.preventDefault();
    const messages = await fetchMessagesFromThread(threadId);
    exportToCsv(messages);
  };

  const deselectAllMessages = () => {
    setSelectedMessages([]);
  };
  const [loading, setLoading] = useState(false);
  const limit = 10;
  const fetchMessages = async (search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("auth-token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/get-threads?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessages(response.data.threads);
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    } catch (error) {
      navigate("/login");
    }
  };
  const [search, setSearch] = useState("");
  useEffect(() => {
    fetchMessages();
  }, [page]);
  // Handle clear search
  const handleClearSearch = (e) => {
    setSearch(""); // Clear the search term
    setPage(1); // Reset pagination to first page
    fetchMessages();
  };
  const onSearch = (e) => {
    setPage(1); // Reset to first page
    fetchMessages(search); // Trigger fetch with the current search term
  };
  if (loading) {
    return (
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
      <LinearProgress color="success" sx={{width: '20%'}}/>
      </div>
    );
  }
  return (
    <Container>
      <Content>
        <h1 style={{ color: "green" }}>All Threads</h1>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "250px",
                padding: "0.5rem",
                borderRadius: "0.5rem",
                border: "1px solid #ccc",
              }}
            />
            <button
              style={{
                padding: "0.5rem",
                borderRadius: "0.5rem",
                border: "1px solid #ccc",
                backgroundColor: "green",
                color: "white",
                cursor: "pointer",
              }}
              onClick={(e) => onSearch(e)}
            >
              Search
            </button>
            {search && (
              <button
                style={{
                  padding: "0.5rem",
                  borderRadius: "0.5rem",
                  border: "1px solid #ccc",
                  backgroundColor: "green",
                  color: "white",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleClearSearch(e);
                }}
              >
                Clear
              </button>
            )}
          </div>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              float: "right",
            }}
          >
            {selectedMessages.length > 0 && (
              <>
                <button
                  style={{
                    padding: "0.5rem",
                    borderRadius: "0.5rem",
                    border: "1px solid #ccc",
                    backgroundColor: loadingExport ? "#ccc" : "green",
                    color: "white",
                    float: "right",
                    cursor: "pointer",
                  }}
                  onClick={(e) => onSelectedExport(e)}
                >
                  Export selected threads
                </button>
                <button
                  style={{
                    padding: "0.5rem",
                    borderRadius: "0.5rem",
                    border: "1px solid #ccc",
                    backgroundColor: "red",
                    color: "white",
                    float: "right",
                    cursor: "pointer",
                  }}
                  onClick={deselectAllMessages}
                >
                  Deselect all
                </button>
              </>
            )}
            <button
              style={{
                padding: "0.5rem",
                borderRadius: "0.5rem",
                border: "1px solid #ccc",
                backgroundColor: loadingExport ? "#ccc" : "green",
                // backgroundColor: 'green',
                color: "white",
                float: "right",
                cursor: "pointer",
              }}
              onClick={(e) => onExport(e)}
            >
              Export all chat
            </button>
          </div>
        </div>
        <TableWrapper>
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0 8px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    color: "black",
                    padding: "10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                ></th>
                <th
                  style={{
                    color: "black",
                    padding: "10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  Thread ID
                </th>
                <th
                  style={{
                    color: "black",
                    padding: "10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  First Message
                </th>
                {/* <th style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}}>Answer</th> */}
                <th
                  style={{
                    color: "black",
                    padding: "10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  Created At
                </th>
                <th
                  style={{
                    color: "black",
                    padding: "10px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {messages.map((message, index) => (
                <tr
                  key={message._id}
                  style={{
                    backgroundColor: index % 2 === 0 ? "white" : "#b5e5b5",
                  }}
                >
                  <td
                    style={{
                      color: "black",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Checkbox
                      checked={selectedMessages.includes(message.threadId)}
                      onChange={(e) =>
                        handleCheckboxChange(message.threadId, e.target.checked)
                      }
                    />
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <a
                      href={`${process.env.REACT_APP_FRONTEND_URL}/?thread-id=${message.threadId}&user=admin`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {message.threadId}
                    </a>
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    {message.messages[0].question}
                  </td>
                  {/* <td style={{color: "black", padding: "10px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"}} dangerouslySetInnerHTML={{ __html: formatRepresentationData(message.answere) }} /> */}
                  <td
                    style={{
                      color: "black",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    {new Date(message.messages[0].createdAt).toLocaleString()}(
                    {Intl.DateTimeFormat().resolvedOptions().timeZone})
                  </td>
                  <td
                    style={{
                      color: "black",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      <Tooltip
                        title="View Chat"
                        onClick={() =>
                          window.open(
                            `${process.env.REACT_APP_FRONTEND_URL}/?thread-id=${message.threadId}&user=admin`,
                            "_blank"
                          )
                        }
                      >
                        <IconButton>
                          <RemoveRedEyeIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title="Download Chat"
                        onClick={(e) => onChatExport(e, message.threadId)}
                      >
                        <IconButton>
                          <CloudDownloadIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableWrapper>
        <Pagination
          sx={{
            marginTop: "1rem",
            "& .MuiPaginationItem-root": {
              color: "black",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              "&:hover": {
                backgroundColor: "grey",
              },
              "&.Mui-selected": {
                backgroundColor: "grey",
              },
            },
          }}
          count={Math.ceil(totalRecords / limit)}
          page={page}
          onChange={(event, value) => {
            setPage(value);
          }}
        />
      </Content>
    </Container>
  );
}

// Helper function to format the representation data
function formatRepresentationData(data) {
  return data
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") // bold text
    .replace(/\n/g, "<br>") // line breaks
    .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>'); // clickable links
}

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  overflow-y: auto;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 2rem;
  width: 100%;
  // max-width: 1200px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;
